export const achievementData = {
  0: {
    name: "Game Completed",
    description: "Completed all levels.",
    image: "https://yourcdn.com/images/achievements/game-completed.png",
  },
  1: {
    name: "Speed Runner",
    description: "Completed a level under par time.",
    image: "https://yourcdn.com/images/achievements/speed-runner.png",
  },
  2: {
    name: "Flawless Victory",
    description: "Completed a level with high health.",
    image: "https://yourcdn.com/images/achievements/flawless.png",
  },
  3: {
    name: "Energy Efficient",
    description: "Finished a level with high energy.",
    image: "https://yourcdn.com/images/achievements/energy.png",
  },
  4: {
    name: "Sharpshooter",
    description: "Achieved high accuracy.",
    image: "https://yourcdn.com/images/achievements/accuracy.png",
  },
  5: {
    name: "Pacifist",
    description: "Completed level with minimal kills.",
    image: "https://yourcdn.com/images/achievements/pacifist.png",
  },
  6: {
    name: "Level 1 Completed",
    description: "You have completed Level 1.",
    image: "https://yourcdn.com/images/achievements/level1.png",
  },
  7: {
    name: "Level 2 Completed",
    description: "You have completed Level 2.",
    image: "https://yourcdn.com/images/achievements/level2.png",
  },
  8: {
    name: "Level 3 Completed",
    description: "You have completed Level 3.",
    image: "https://yourcdn.com/images/achievements/level3.png",
  },
  9: {
    name: "Level 4 Completed",
    description: "You have completed Level 4.",
    image: "https://yourcdn.com/images/achievements/level4.png",
  },
  10: {
    name: "Level 5 Completed",
    description: "You have completed Level 5.",
    image: "https://yourcdn.com/images/achievements/level5.png",
  },
  11: {
    name: "Level 6 Completed",
    description: "You have completed Level 6.",
    image: "https://yourcdn.com/images/achievements/level6.png",
  },
  12: {
    name: "Level 7 Completed",
    description: "You have completed Level 7.",
    image: "https://yourcdn.com/images/achievements/level7.png",
  },
  13: {
    name: "Level 8 Completed",
    description: "You have completed Level 8.",
    image: "https://yourcdn.com/images/achievements/level8.png",
  },
};
